/* eslint-disable import/prefer-default-export, react/prop-types */
import React from "react";
import TopLayout from "./TopLayout";

// Polyfill for Map.prototype[@@iterator] if needed
if (typeof Map !== "undefined" && !Map.prototype[Symbol.iterator]) {
  Map.prototype[Symbol.iterator] = Map.prototype.entries;
}

export const wrapRootElement = ({ element }) => {
  return <TopLayout>{element}</TopLayout>;
};
